import { Select } from 'antd';
import React from 'react';
import { CountryFlag } from 'store/common/models';
import { getCountryLabel } from 'i18n/countryLabel';

const FLAG_PLACEHOLDER_STYLE: React.CSSProperties = {
  width: 24,
  height: 16,
  marginLeft: '5px',
  marginRight: '10px',
  marginTop: '3px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 9,
  fontWeight: 600,
  backgroundColor: '#e8e8e8',
  color: '#666',
  borderRadius: 2,
};

export const renderPhoneCodeOption = (
  country: CountryFlag,
  language: string
): React.JSX.Element => {
  const countryName = getCountryLabel(
    country.cca2,
    country.name.common.includes(',')
      ? country.name.common.split(',')[0]
      : country.name.common,
    language
  );
  const phoneCode =
    country.idd.root == '' && country.idd.suffixes.length == 0
      ? '+672'
      : country.idd.root + country.idd.suffixes[0];
  const cca2 = country.cca2 ?? '';

  return (
    <Select.Option
      key={country.name?.official}
      value={country.idd.root + country.idd.suffixes[0]}
      label={`${countryName} ${phoneCode}`}
      style={{ padding: '5px 10px', fontSize: '13px' }}
    >
      <div style={{ display: 'flex' }}>
        <CountryFlagImage
          src={country.flags.png}
          alt={country.flags.alt}
          cca2={cca2}
        />
        <span>{`${countryName} ${phoneCode}`}</span>
      </div>
    </Select.Option>
  );
};

export function CountryFlagImage({
  src,
  alt,
  cca2,
}: {
  src: string | undefined;
  alt: string;
  cca2: string;
}): React.JSX.Element {
  const [errored, setErrored] = React.useState(false);
  if (errored || !src) {
    return (
      <span style={FLAG_PLACEHOLDER_STYLE} title={alt || cca2}>
        {cca2 || '?'}
      </span>
    );
  }
  return (
    <img
      width={24}
      height={16}
      alt={alt}
      src={src}
      style={{
        marginLeft: '5px',
        marginRight: '10px',
        marginTop: '3px',
      }}
      onError={() => setErrored(true)}
    />
  );
}
